import{useMst}from'@models/RootStore';import{useTranslationEnabled}from'./useTranslationEnabled';/**
 * Whether the practice may trigger automatic translations (Azure).
 *
 * True only when ALL of these hold:
 * - the `ai` feature flag is on and the practice has activated at least one
 *   language besides German (`useTranslationEnabled`)
 * - the per-practice `office_translations` feature flag is on
 *
 * When false, the doctor must not see any button that starts an automatic
 * translation or subtitle generation. Manual translation editing (typing
 * translations, UpdateXTranslation, UpdateBlockSubtitles) stays possible,
 * and viewing existing translations stays too - both are gated by
 * `useTranslationEnabled` alone, not by this hook.
 */export function useOfficeTranslationsEnabled(){var _store$session$office,_store$session$office2;const store=useMst();const translationEnabled=useTranslationEnabled();return translationEnabled&&((_store$session$office=(_store$session$office2=store.session.office)===null||_store$session$office2===void 0?void 0:_store$session$office2.featureIsEnabled('office_translations'))!==null&&_store$session$office!==void 0?_store$session$office:false);}